import { useState } from 'react';
import { faqItems, site } from '@/mocks/gossip';

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="mx-auto max-w-4xl px-4 py-10 md:px-6 md:py-14">
      <div className="mb-8 text-center">
        <p className="mb-2 inline-flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-600">
          <span className="h-px w-6 bg-primary-500" />
          FAQ
          <span className="h-px w-6 bg-primary-500" />
        </p>
        <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">关于{site.brand}，你可能想知道</h2>
        <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">关于内容来源、更新节奏与投稿报料的常见疑问，这里一次讲清楚。</p>
      </div>

      <div className="divide-y divide-background-200 rounded-xl border border-background-200 bg-background-50">
        {faqItems.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={i}>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition hover:bg-secondary-100/50 md:px-6"
              >
                <h3 className="text-sm font-semibold text-foreground-950 md:text-[15px]">{f.q}</h3>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                    isOpen ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-foreground-700'
                  }`}
                >
                  <i className={`ri-add-line text-base transition-transform ${isOpen ? 'rotate-45' : ''}`} />
                </span>
              </button>
              <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 text-sm leading-7 text-foreground-700 md:px-6">{f.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}